import {
  useState, useCallback, useEffect, useMemo, useRef,
} from 'react';
import { useTranslation } from 'react-i18next';
// import { message } from 'antd';
import moment from 'moment';
import requestHelpers from '@utils/helpers/forRequest';
import devicesApi from '@api/devicesApi';
import arrayValueType from '@utils/dictionaries/arrayDataValueTypes';
import { useSelector } from 'react-redux';
import getColumns from './getColumns';
import getColumnsDetail from './getColumnsDetail';
import getColumnsDataInfo from './getColumnsDataInfo';

function useTableNotification() {

  const { t } = useTranslation();
  // const clientTarget = useSelector(({ user: u }) => u.clientTarget);

  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState(null);
  const [dataSourceModal, setDataSourceModal] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectModal, setSelectModal] = useState(false);
  const [visible, setVisible] = useState(false);
  const paginationRef = useRef({ current: 1, pageSize: 100 });
  const tableFiltersRef = useRef({});
  const othersFiltersRef = useRef({});
  const device = useSelector(({ telemetry }) => telemetry.generalInfo.device);
  const inverterModel = useSelector(({ telemetry }) => telemetry.generalInfo.inverterModel);
  const columns = useMemo(() => getColumns({ setSelectedItem, t }), [t]);
  const columnsDetail = useMemo(() => getColumnsDetail({ setSelectedItem, t }), [t]);
  const columnsDataInfo = useMemo(() => getColumnsDataInfo({ t }), [t]);

  const { valueType } = arrayValueType;

  const makeRequest = useCallback(() => {

    const { current, pageSize: limit } = paginationRef.current;
    const offset = (current - 1) * limit;
    const filters = { ...tableFiltersRef.current, ...othersFiltersRef.current };

    devicesApi
      .getLogsInverter({
        offset, limit, ...filters,
      })
      .then((response) => {

        const total = response.length;
        const results = response.map((values) => {

          const data = {
            name: values.name,
            time: values.time,
            description: values.description,
            device: values.device,
            inverter: values.inverter,
            client: values.client,
          };
          return data;

        });
        paginationRef.current = { ...paginationRef.current, total };

        setDataSource(results);
        setDataSourceModal(results);

      })
      .catch((resError) => {

        const { fem } = resError;
        console.log(t(fem));

      });

  }, [t, selectModal]);

  const onChangeRangeDates = useCallback(
    (dates) => {

      const [start_date, end_date] = dates
        ? dates.map(requestHelpers.getDateFormatForRequest)
        : [undefined, undefined];
      othersFiltersRef.current = {
        ...othersFiltersRef.current, start_date, end_date,
      };

      paginationRef.current = { ...paginationRef.current, current: 1 };
      if (start_date && end_date) makeRequest();

    },
    // eslint-disable-next-line
    []
  );

  const handleChangetable = () => {

    setLoading(true);
    setVisible(true);

  };

  const reStartData = () => {

    const start_date = moment().subtract(7, 'days').utcOffset('+00:00').format('YYYY-MM-DD HH:mm:ss');
    const end_date = moment().utcOffset('+00:00').format('YYYY-MM-DD HH:mm:ss');
    othersFiltersRef.current = {
      ...othersFiltersRef.current,
      start_date,
      end_date,
    };
    setSelectModal(false);
    makeRequest();
    setLoading(false);
    setVisible(false);

  };

  const handleTableChange = useCallback(
    (pagination, filters, sorter) => {

      const mapFilter = filters
        ? Object.entries(filters).reduce((acc, cur) => {

          const [key, value] = cur;
          if (!value) return acc;
          acc[key] = value.join(',');
          return acc;

        }, {})
        : undefined;

      paginationRef.current = { ...paginationRef.current, ...pagination };
      tableFiltersRef.current = mapFilter;

      makeRequest();

    },
    // eslint-disable-next-line
    []
  );

  const onSearch = useCallback((deviceField) => {

    if (!deviceField) {

      const newOthersFiltersRef = { ...othersFiltersRef.current };
      delete newOthersFiltersRef.deviceField;
      othersFiltersRef.current = newOthersFiltersRef;

    } else {

      othersFiltersRef.current = { ...othersFiltersRef.current, deviceField };

    }

    paginationRef.current = { ...paginationRef.current, current: 1 };
    makeRequest();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {

    const start_date = moment().subtract(7, 'days').utcOffset('+00:00').format('YYYY-MM-DD HH:mm:ss');
    const end_date = moment().utcOffset('+00:00').format('YYYY-MM-DD HH:mm:ss');

    othersFiltersRef.current = {
      ...othersFiltersRef.current,
      start_date,
      end_date,
      device,
      inverter: inverterModel,
    };

    handleTableChange(paginationRef.current);

    const interval = setInterval(() => {

      makeRequest();

    }, 50000);
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [device, inverterModel]);

  return {
    selectedItem,
    onChangeRangeDates,
    onSearch,
    loading,
    dataSource,
    dataSourceModal,
    columns,
    columnsDetail,
    handleChangetable,
    reStartData,
    visible,
    columnsDataInfo,
    valueType,
  };

}

export default useTableNotification;
